import React from 'react';
import { SandpackCodeEditor } from '@codesandbox/sandpack-react';

export interface SandboxCodeEditorProps {
  showLineNumbers?: boolean;
  showInlineErrors?: boolean;
  showTabs?: boolean;
  style?: React.CSSProperties;
}

/**
 * Code editor panel — must be rendered inside a SandboxProvider.
 */
export function SandboxCodeEditor({
  showLineNumbers = true,
  showInlineErrors = true,
  showTabs = true,
  style,
}: SandboxCodeEditorProps): React.ReactElement {
  return (
    <SandpackCodeEditor
      showLineNumbers={showLineNumbers}
      showInlineErrors={showInlineErrors}
      showTabs={showTabs}
      style={style ?? { height: '100%' }}
    />
  );
}
